import api from './../service/apiService'
import {catchJSException} from './../service/logService'
import { DOFlow } from './../constants/actionType'
import { InHomeUtils } from './../util/inhomeUtils';
import { apiUrl } from './../constants/apiUrl'



export const updateVendorDetails = (value, dispatch) => {
  dispatch({ type: 'VENDOR_DETAILS', value: value })
};

export const setReferralUrl = (dispatch, value) => {
  dispatch({ type: "SET_REFERRAL_URL", value });
};

export const updateDOFlowDetails = (doidvalue, dispatch) => {
  dispatch({ type: DOFlow.onDoFlowCreation, value: doidvalue })
};



export const validateVendorToken = async (vtokenValue, props) => {
  try {
    let url = '/inhome/validatevendortoken';
    const response = await api(url, 'POST', JSON.stringify({ vtoken: vtokenValue }));
    const { tokenvalidated, visitId, visitorId } = response.data;
    if (tokenvalidated) {
      window.localStorage.setItem('isvtokenvalidated', tokenvalidated);
      props.dispatch({ type: "UPDATE_VISITID", value: { visitId: visitId, visitorId: visitorId } });
      props.dispatch({ type: "PAGE_VISITID", value: { prevPage: props.location, currentPage: props.location } });
    }
    return response;
  }
  catch (ex) {
    catchJSException('loopQual2.0', props.appState.visitId, 'validateVendorToken', ex);
  }
}

export const setVendorRequest = (dispatch, visitId, visitorId, inputDetail,  isTarget) => {
  try {
      let url = apiUrl().vendorFlow;
      dispatch({
          type: 'LOADER_ACTIVE',
          value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" }
      });
      api(url, 'POST', vendorRequest(inputDetail, visitId, visitorId)).then(response => {
          if (InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, '200')) {
              dispatch({ type: 'VENDOR_RESPONSE', value: response.data });
              if (InHomeUtils.isNotNull(response.data) && response.data.isVendorFlowAllowed && response.data.visitid !== "" && response.data.visitorid !== "") {
                  visitId = response.data.visitid;
                  visitorId = response.data.visitorid;
                  setVendorCookie(visitId, visitorId);                 
                  dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
              }
              else {
                  dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
              }
          }
          else {
              dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
          }
      })
          .catch(error => {
              let errorMsg = `MethodName:setVendorRequest,errorMessage:${error.message}`;
              logKafka("ERROR", "loopQual", errorMsg, getErrorLogUrl, "applogs", visitId);
              dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
              vzdlErrorUpdate(error.code === undefined ? "" : error.code, errorMsg);
          });
  }
  catch (ex) {
      catchJSException('loopQual', visitId, 'setVendorRequest', ex);
  }
};

export const setVendorCookie = async (visitId,visitorId) => {
  try {
      let url = '/inhome/generatevisitidforvendor';
      let request = {
          other_visit_id: visitId,
          other_visitor_id: visitorId,
          other_GSM_ID: ''
      }
      const response = await api(url, 'POST', JSON.stringify(request));
      if (response) {
          const { visit_id, visitor_id, expirationTime } = response.data;
          window.localStorage.setItem('visit_id', visit_id);
          window.localStorage.setItem('visitor_id', visitor_id);
          window.localStorage.setItem('expirationTime', expirationTime);
          window.sessionStorage.setItem('visit_id', visit_id);
          window.sessionStorage.setItem('visitor_id', visitor_id);
      }
      return;
  }
  catch (ex) {
      catchJSException('loopQual2.0', props.appState.visitId, 'setVendorCookie', ex);
  }
}


const vendorRequest = (inputDetail, visitId, visitorId) => {
  let request = {
      leadListDetails: {
          visitId: visitId !== "" ? visitId : "",
          visitorId: visitorId !== "" ? visitorId : "",
          config: {
              storeId: InHomeUtils.isNotNull(inputDetail.storeid) ? inputDetail.storeid : "",
              doid: inputDetail.doid !== "" ? inputDetail.doid : "",
              location: "",
              lob: "",
              vendorId: "",
              locationId: "",
              sessionId: "",
              repInfo: {
                  repId: InHomeUtils.isNotNull(inputDetail.repid) ? inputDetail.repid : "",
                  userId: "",
                  firstName: "",
                  lastName: "",
                  repName: "",
              }
          }
      },
      vendorQueryDetails: {
          c: InHomeUtils.isNotNull(inputDetail.cVal) ? inputDetail.cVal : "",
          cmpId: InHomeUtils.isNotNull(inputDetail.cmp) ? inputDetail.cmp : "",
          abrVal: InHomeUtils.isNotNull(inputDetail.abrVal) ? inputDetail.abrVal : "",
          dig: inputDetail.dig ? inputDetail.dig.toUpperCase() : ""
      }
  }
  return JSON.stringify(request);
}
  